<template>
  <span v-tooltip.top="tooltipSetup" :class="props.customStyle" :data-testid="props.dataTestId">
    <QuestionMarkCircleIcon :class="props.iconStyle" />
  </span>
</template>

<script setup>
import Tooltip from "primevue/tooltip";
import { QuestionMarkCircleIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  customStyle: {
    type: String,
    required: false,
    default: "inline-block",
  },
  iconStyle: {
    type: String,
    required: false,
    default: "h-[1.125rem] w-[1.125rem]",
  },
  message: {
    type: String,
    required: false,
    default: "",
  },
  dataTestId: {
    type: String,
    default: `tooltip-id-${Date.now() + Math.floor(Math.random() * 10000)}`,
  },
  escape: {
    type: Boolean,
    default: true,
  },
});

// Adding new directive v-tooltip
const vTooltip = Tooltip;

const tooltipSetup = {
  value: props.message,
  escape: props.escape,
  id: "duration-tooltip",
  class: "bg-white max-w-xs shaddow rounded white",
  hideDelay: "0.3",
  pt: {
    text: "text-indigo-base p-3 leading-none",
  },
};
</script>
